import React, { Component, useContext } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Notification from '../Notification/Notification';

export const NotificationContext = React.createContext({
	isOpen: false,
	notification: null,
	addNotification: () => {},
});

export class NotificationProvider extends Component {
	notificationContainerID = '__notification-container';
	notificationContainer = document.createElement('div');

	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			notification: null,
			addNotification: this.addNotification,
			removeNotification: this.removeNotification,
		};
		this.createNotificationContainer();
		this.addListenerForEscapeKey();
	}

	componentWillUnmount() {
		this.removeListenerForEscapeKey();
	}

	createNotificationContainer = () => {
		this.notificationContainer.setAttribute(
			'id',
			this.notificationContainerID,
		);
		document.body.appendChild(this.notificationContainer);
	};

	addListenerForEscapeKey = () => {
		window.addEventListener('keyup', this.onKeyUp);
	};

	removeListenerForEscapeKey = () => {
		window.removeEventListener('keyup', this.onKeyUp);
	};

	onKeyUp = ({ keyCode }) => {
		if (this.state.isOpen && keyCode === 27) {
			this.removeNotification();
		}
	};

	addNotification = notification =>
		this.setState({
			notification,
			isOpen: true,
		});

	removeNotification = () =>
		this.setState({
			isOpen: false,
		});

	render = () => {
		const {
			state,
			state: { isOpen, notification },
			props: { children },
		} = this;
		return (
			<NotificationContext.Provider value={state}>
				{children}
				{ReactDOM.createPortal(
					<Notification
						isOpen={isOpen}
						notification={notification}
						onNotificationClose={this.removeNotification}
					/>,
					this.notificationContainer,
				)}
			</NotificationContext.Provider>
		);
	};
}

export const withNotifications = WrappedComponent => {
	const Component = props => {
		const { addNotification } = useContext(NotificationContext);

		return (
			<WrappedComponent
				{...props}
				notifications={{
					addNotification,
				}}
			/>
		);
	};

	return Component;
};

export const NotificationsHOCProps = {
	notifications: PropTypes.shape({
		addNotification: PropTypes.func,
	}),
};

NotificationProvider.propTypes = {
	children: PropTypes.any,
};
